export const PUBLIC_ROUTE = {
  LANDING: '/',
  GKS: '/gks',
  STEP_ONE_DOT_ONE: '/step-one-dot-one',
  STEP_ONE_DOT_TWO: '/step-one-dot-two',
  STEP_TWO: '/step-two',
  STEP_THREE: '/step-three',
  INFORMATION: '/information',
  SUCCESSFUL_RESULT: '/success',
  ERROR_RESULT: '/error',
  WELCOME: '/welcome',
  OTHER: '/other',
  STEP_TWO_OTHER: '/step-two-other',
  SUCCESSFUL_OTHER: '/success-other',
  SERVER_ERROR: '/server-error',
};
